let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bIXw1"), load("dXN7B")]).then(() => parcelRequire('lzjf5'));